import { render, staticRenderFns } from "./purchased.vue?vue&type=template&id=fd9e767a&"
import script from "./purchased.ts?vue&type=script&lang=ts&"
export * from "./purchased.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports